(function () {
  'use strict';
  if (!window || !window.IntersectionObserver) return;
  var REDUCED = false;
  try { REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* Small text + feature cards: fade+rise. Render instantly, so no empty box. */
  var FADE_SEL = '.yw-section__head, .yw-why__card, .yw-trust__item, .yw-vr__header, .yw-pdp__head, .yw-pdp__panel';
  /* Images: clip+scale reveal (never opacity-hidden, so no empty box). */
  var IMG_SEL = '.yw-vr__media img, .yw-showcase__grid img, .card-media img';

  /* One-shot init visibility test (not a scroll/resize handler):
     anything already visible on first paint is NEVER hidden or animated. */
  function inViewport(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  }

  function setup() {
    if (REDUCED) return;
    function settle(el) {
      el.classList.remove('yw-reveal', 'yw-reveal--in', 'yw-reveal--fade', 'yw-reveal--img');
      el.style.removeProperty('--yw-reveal-delay');
      el.style.willChange = '';
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var el = en.target;
          io.unobserve(el);
          el.addEventListener('transitionend', function () { if (el.classList.contains('yw-reveal--in')) settle(el); });
          el.classList.add('yw-reveal--in');
          setTimeout(function () { if (el.classList.contains('yw-reveal--in')) settle(el); }, 900); // fallback if transitionend is missed
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });

    function arm(el, cls, delay) {
      if (el.dataset.ywRv) return;           // already animated — never re-run
      el.dataset.ywRv = '1';
      if (delay) el.style.setProperty('--yw-reveal-delay', delay + 'ms');
      el.classList.add('yw-reveal', cls);
      io.observe(el);
    }

    function init() {
      var byParent = new Map();
      document.querySelectorAll(FADE_SEL).forEach(function (el) {
        if (el.dataset.ywRv || inViewport(el)) return;  // visible now → leave untouched
        var parent = el.parentElement || document.body;
        var idx = byParent.get(parent) || 0;
        arm(el, 'yw-reveal--fade', Math.min(idx * 75, 450));
        byParent.set(parent, idx + 1);
      });
      document.querySelectorAll(IMG_SEL).forEach(function (el) {
        if (el.dataset.ywRv || inViewport(el)) return;
        arm(el, 'yw-reveal--img');
      });
    }

    init();
    /* Shop Ajax (quick view / card swaps) can inject fresh markup; pick it up, guarded. */
    var pending = false;
    document.addEventListener('shopify:section:load', function () {
      if (pending) return; pending = true;
      requestAnimationFrame(function () { pending = false; init(); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
